
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class BrushedMetalEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const lines = Math.floor(100 * (config.parallaxComplexity || 1.0));
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.15 / (layerIndex + 1);
            for (let i = 0; i < lines; i++) {
                const y = (this.pseudoRandom(i) - 0.5) * height * 2.5;
                ctx.lineWidth = (1 + this.pseudoRandom(i + 1) * 2) * scale;
                ctx.beginPath();
                ctx.moveTo(-width * 2, y);
                ctx.lineTo(width * 2, y);
                ctx.stroke();
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
